import React, { useState, useEffect } from "react";
import bannerImage from "../assets/3i-banner.png";
import bannerImageMobile from "../assets/3i-banner-mobile.png";

const MKTBanner = () => {
  const [imageSrc, setImageSrc] = useState(bannerImage);

  useEffect(() => {
    const updateImage = () => {
      setImageSrc(window.innerWidth < 768 ? bannerImageMobile : bannerImage);
    };

    updateImage();
    window.addEventListener("resize", updateImage);

    return () => window.removeEventListener("resize", updateImage);
  }, []);

  return (
    <div className="w-full bg-gradient-to-r from-violet-50 via-purple-50 to-indigo-50 border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <a
          href="https://3iapps.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          className="block relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 group bg-white"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-violet-600/5 to-purple-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <img
            src={imageSrc}
            alt="3i Organization - Crypto & Web3 Solutions"
            className="w-full h-auto object-cover transition-all duration-300 group-hover:scale-[1.02]"
            loading="eager"
            decoding="async"
          />
          <div className="absolute top-2 right-2 bg-violet-600 text-white text-xs font-semibold px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
            Visit Website →
          </div>
        </a>
      </div>
    </div>
  );
};

export default MKTBanner;
